import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { LEGAL_DOCS } from '@/features/legal/documents';
import { ROUTES } from '@/router';
import { useLocalizedPath } from '@/seo/useLocalePath';

/** docs/LEGAL.md — the terms, the privacy notice and the risk notice, for the public footers. */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation();
  const localized = useLocalizedPath();
  return (
    <nav className={className} aria-label={t('legal.navLabel')}>
      {LEGAL_DOCS.map((doc) => (
        <Link key={doc} to={localized(ROUTES[doc])}>
          {t(`legal.${doc}`)}
        </Link>
      ))}
    </nav>
  );
}
